
const InquiryIdType = Symbol();

export class InquiryId {

    [InquiryIdType]: any;
    readonly value: string;

    private constructor(
        value: string
    ) {
        this.value = value;
    }

    static fromString(value: string): InquiryId {
        return new InquiryId(value);
    }
}
